import ScalarIconEnvelope_vue_vue_type_script_setup_true_lang_default from "./ScalarIconEnvelope.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconEnvelope.vue
var ScalarIconEnvelope_default = ScalarIconEnvelope_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconEnvelope_default as default };

//# sourceMappingURL=ScalarIconEnvelope.js.map